<template>
  <div class="vd-page-dialog">
    <vd-dialog visible maximized :title="title" :type="type" :hide-close-button="hideCloseButton" @close="onClose">
      <VdPage :subtitle="subtitle" :loading="loading">
        <template #actions>
          <slot name="page-actions" />
        </template>
        <slot />
      </VdPage>

      <template #footer>
        <div class="footer">
          <slot name="footer" :on-close="onClose" />
        </div>
      </template>
    </vd-dialog>
  </div>
</template>

<script lang="ts">
import { VdPage } from "@voodoo.io/voodoo-ui";
import { defineComponent, PropType } from "vue";
import { RouteLocationRaw, useRouter } from "vue-router";

/**
 * This structural component represents a VDPage in a modal dialog.
 * This component should be treated like a page (ie should be referenced in the router)
 * and be used in a router-view on the parent page.
 * The close button should redirect to the parent page.
 */
export default defineComponent({
  name: "VDPageDialog",

  components: {
    VdPage,
  },

  props: {
    /**
     * The page title
     */
    title: {
      type: String,
      default: "",
    },

    /**
     * The page subtitle
     */
    subtitle: {
      type: String,
      default: "",
    },

    /**
     * The route location use when clicking on the close button
     */
    backLink: {
      type: [Object, String] as PropType<RouteLocationRaw>,
      default: () => null,
    },

    /**
     * the type of dialog: info | error
     */
    type: {
      type: String,
      default: "info",
    },

    /**
     * Status of the page loading
     */
    loading: Boolean,

    /**
     * Wether do display the hide button
     */
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["close"],

  setup(props, { emit }) {
    const router = useRouter();
    const onClose = () => {
      if (props.backLink) {
        router.push(props.backLink);
      } else {
        emit("close");
      }
    };

    return {
      onClose,
    };
  },
});
</script>
